import { filter } from "lodash";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// material
import { Card, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { Stack, Container, TextField, Button, MenuItem, Tooltip, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Select from "react-select";
import {
  fetchBusinessList,
  fetchVisitorList,
  fetchChaptList,
  fetchchapterbyuser,
  fetchallcitylist
} from "src/utils/common";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
// components
import Page from "../components/Page";
import { deleteVisitorData, getAllvisitorV1, GetMemberByChptId } from "src/api/commonapi";
import { DeleteForever, DeleteOutline, DeleteSharp, EditSharp } from "@mui/icons-material";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import moment from "moment";
import ChapterSelectDropDown from "src/components/ChapterSelectDropDown";
import Label from "src/components/Label";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function Visitor() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  const [joindate, setjoinDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [chptdata, setchptdata] = useState([]);
  const [amount, setamount] = useState({});
  const [visitorData, setvisitorData] = useState([]);

  const [chapoption, setchptoption] = useState([]);
  const [memberdata, setmemberdata] = useState([]);
  const [getdata, setgetdata] = useState({});
  const [step, setstep] = useState(0);
  const [filter, setFilter] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : 0,
    chpt_id: 0
  });

  const [selectedmember, setselectedmember] = useState({
    defaulselect: "",
    m_id: 0
  });

  const getchptlist = async () => {
    setchptdata(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  };
  useEffect(
    (async) => {
      chptdata?.map((option) => {
        chapoption.push({ value: option.chpt_id, label: option.chpt_name });
      });
    },
    [chptdata]
  );
  const getmemberbychp = async (ch_id) => {
    setselectedmember({ defaulselect: "", m_id: 0 });
    setmemberdata(await GetMemberByChptId(ch_id));
  };
  const getvisitorlist = async (ch_id, m_id) => {
    setIsLoading(true);
    setvisitorData((await getAllvisitorV1({ chpt_id: ch_id, member_id: m_id })).data);
    setIsLoading(false);
  };
  const deleteVisitor = async (v_id) => {
    const resp = await deleteVisitorData(v_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      getvisitorlist(filter.chpt_id, selectedmember.m_id);
      setDvisible({ mval: false, id: 0 });
    }
  };
  useEffect(async () => {
    getchptlist();
  }, []);
  const expo_columns = [
    { label: "No", key: "row_no" },
    { label: "Invite By", key: "v_by_name" },
    { label: "Visitor Name", key: "visitor_name" },
    { label: "Visitor Business", key: "visitor_business_name" },
    { label: "Contact Number", key: "visitor_mo_no" },
    { label: "Business Category", key: "visitor_business_category" },
    { label: "Visitor Type", key: "visitor_in_chapter_type" },
    { label: "Invited At", key: "other_chapter_name" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row) => row.row_no,
      sortable: true,
      width: "100px",
      wrap: true
    },
    {
      name: "Invite By",
      selector: (row) => row.v_by_name + " (" + row.member_Business + ")",
      sortable: true,
      wrap: true
    },
    {
      name: "Visitor Name",
      selector: (row) => row.visitor_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Visitor Business",
      selector: (row) => row.visitor_business_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Contact Number",
      selector: (row) => row.visitor_mo_no,
      sortable: true,
      wrap: true
    },
    {
      name: "Business Category",
      selector: (row) => row.visitor_business_category,
      sortable: true,
      wrap: true
    },
    {
      name: "Visitor Type",
      sortable: true,
      selector: (row) => row.visitor_in_chapter_type
    },
    {
      name: "Invited At",
      sortable: true,
      wrap: true,
      selector: (row) => row.other_chapter_name
    },
    {
      name: "Action",
      sortable: true,
      wrap: true,

      selector: (row) => (
        <>
          <>
            <Tooltip title="Delete Visitor">
              <IconButton
                onClick={() => {
                  setDvisible({ mval: true, id: row.v_id });
                }}
              >
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </>
        </>
      )
    }
  ];

  const [citylist, setcitylist] = useState([]);

  const [chaptlist, setchaplist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
    setchaplist(await fetchchapterbyuser(loginUser?.city_id, loginUser?.u_type));
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deleteVisitor} />
      <Page title="Visitor | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Visitor List
            </Typography>
          </Stack>

          <Card className="p-20">
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setFilter({ ...filter, city_id: e.value, chpt_id: 0 });
                    }}
                    value={
                      filter.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              filter.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>
              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setFilter({ ...filter, chpt_id: e.value });
                      getmemberbychp(e.value);
                      getvisitorlist(e.value);
                    }}
                    options={[
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (filter?.city_id != 0) {
                              if (filter?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      chaptlist &&
                      chaptlist.map((c) => {
                        if (c.chpt_id == filter.chpt_id) {
                          return {
                            value: c.chpt_id,
                            label: c.chpt_name
                          };
                        }
                      })
                    }
                  />
                  {/* <ChapterSelectDropDown
                    dropDownLabel={"Select Chapter"}
                    selectedState={filter}
                    chapterKey="chpt_id"
                    handleChange={(e) => {
                      setFilter({ chpt_id: e.value });
                      getmemberbychp(e.value);
                    }}
                  /> */}
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3}>
                  <label>Select Member</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={selectedmember.defaulselect}
                    onChange={(e) => {
                      setselectedmember({ defaulselect: e, m_id: e.value });
                      getvisitorlist(filter.chpt_id, e.value);
                    }}
                    options={
                      memberdata &&
                      memberdata.map((option) => {
                        return { value: option.m_id, label: option.m_name };
                      })
                    }
                  />
                </Stack>
              </Grid>
            </Grid>
          </Card>

          <Card className="p-20" sx={{ mt: 2 }}>
            {visitorData && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={visitorData}
                    headers={expo_columns}
                    filename={"Visitor Data" + moment().format("DD-MM-YYYY") + ".csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={visitorData}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
}
